
import { defineComponent, computed, reactive } from 'vue';
import { useStore } from 'vuex';
import { i18n } from '@/functions';

export default defineComponent({
  props: {
    code: String,
  },
  setup(props) {
    const $store = useStore();
    const loading = computed(() => $store.state.loading);
    const state = reactive({
      progressInterval: 0,
      progress: 0,
    });
    const showProgress = () => {
      let step = 0.5;
      let currentProgress = 0;
      return setInterval(() => {
        currentProgress += step;
        state.progress = Math.round(
          (Math.atan(currentProgress) / (Math.PI / 2)) * 100 * 1000,
        ) / 1000;
        if (state.progress >= 100) {
          if (state.progressInterval) clearInterval(state.progressInterval);
          state.progress = 0;
        } else if (state.progress >= 70) step = 0.1;
      }, 500);
    };
    state.progressInterval = showProgress();
    const loadingText = () => (!props.code
      ? loading.value.map((text: string) => i18n.loading[text]).join(', ')
      : i18n.loading[props.code]);

    return {
      state,
      loading,
      loadingText,
    };
  },
});
